import { render, staticRenderFns } from "./IncTreeTable.vue?vue&type=template&id=b649363e&scoped=true&"
import script from "./IncTreeTable.vue?vue&type=script&lang=ts&"
export * from "./IncTreeTable.vue?vue&type=script&lang=ts&"
import style0 from "./IncTreeTable.vue?vue&type=style&index=0&id=b649363e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b649363e",
  null
  
)

export default component.exports